import React, { useState } from 'react';
import { Button, FormGroup, Input, Label } from 'reactstrap';
import DisplayImage from 'src/components/Common/displayImage';
import { config } from 'src/config';
import { useLazyGetFellowInformationQuery } from 'src/rtk/features/trainee/traineeApi';

const FellowInformation = () => {

    const [bmdcNumber, setBmdcNumber] = useState<string>('');
    const [fellowNumber, setFellowNumber] = useState<string>('');

    const [getFellowInformation, { data, isLoading, isSuccess, isError, error }] = useLazyGetFellowInformationQuery();

    const handleFellowSearch = () => {
        const params = {
            bmdc_registration_no: bmdcNumber,
            fellow_number: fellowNumber
        };
        getFellowInformation(`fellow_number=${params.fellow_number}&bmdc_registration_no=${params.bmdc_registration_no}`);
    };

    return (
        <React.Fragment>
            <div className='page-content bg-success bg-opacity-10'>
                {/* Section 1: Search Form */}
                <div className='d-flex justify-content-center mb-5'>
                    <div className='w-25'>
                        <h4 className='text-center d-block mb-4'>Searching For Fellow</h4>

                        <FormGroup>
                            <Label>BMDC Number</Label>
                            <Input
                                type='text'
                                name="bmdcNumber"
                                placeholder="Enter BMDC Number"
                                value={bmdcNumber}
                                onChange={(e) => setBmdcNumber(e.target.value)}
                            />
                        </FormGroup>

                        <FormGroup>
                            <Label>Fellow Number</Label>
                            <Input
                                type='text'
                                name="fellowNumber"
                                placeholder="Enter Fellow Number"
                                value={fellowNumber}
                                onChange={(e) => setFellowNumber(e.target.value)}
                            />
                        </FormGroup>

                        <FormGroup className='text-center'>
                            <Button
                                color='success'
                                type='button'
                                onClick={() => {
                                    handleFellowSearch();
                                }}
                            >
                                Submit
                            </Button>
                        </FormGroup>
                    </div>
                </div>

                {/* Section 2: Results */}
                <div className='d-flex justify-content-center'>
                    <div className='w-50'>
                        {isLoading && (
                            <div className='text-center'>
                                <div className='card shadow border-0'>
                                    <div className='card-body p-4'>
                                        <div className='spinner-border text-primary' role='status'>
                                            <span className='visually-hidden'>Loading...</span>
                                        </div>
                                        <p className='mt-3 mb-0'>Loading...</p>
                                    </div>
                                </div>
                            </div>
                        )}

                        {isError && (
                            <div className='text-center'>
                                <div className='card shadow border-0'>
                                    <div className='card-body p-4'>
                                        <div className='alert alert-danger mb-0' role='alert'>
                                            <i className='bi bi-exclamation-triangle-fill me-2'></i>
                                            Error: {(error as any)?.data?.message || 'An error occurred'}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {isSuccess && data && (
                            <div>
                                <div className='card shadow-lg border-0'>
                                    <div className='card-header bg-success bg-opacity-50 text-white text-center'>
                                        <h5 className='mb-0'>Fellow Information</h5>
                                    </div>
                                    <div className='card-body p-4'>
                                        <div className="img-fluid img-rounded text-center">
                                            {data?.data?.personal_info?.picture &&
                                                <DisplayImage className="img-thumbnail profile-img-width" src={`${config?.APP_URL}${data?.data?.personal_info?.picture}`} />
                                            }
                                        </div>
                                        <div className='table-responsive'>
                                            <table className='table table-hover mb-0'>
                                                <tbody>
                                                    <tr>
                                                        <td className='fw-bold text-muted border-0 py-3'>Name:</td>
                                                        <td className='border-0 py-3'>{data?.data?.personal_info?.full_name}</td>
                                                    </tr>
                                                    <tr className='table-light'>
                                                        <td className='fw-bold text-muted border-0 py-3'>BMDC Registration:</td>
                                                        <td className='border-0 py-3'>{data?.data?.bmdc_registration_no}</td>
                                                    </tr>
                                                    <tr >
                                                        <td className='fw-bold text-muted border-0 py-3'>Fellow Number:</td>
                                                        <td className='border-0 py-3'>{data?.data?.fellow_number}</td>
                                                    </tr>
                                                    <tr className='table-light'>
                                                        <td className='fw-bold text-muted border-0 py-3'>Subject:</td>
                                                        <td className='border-0 py-3'>{data?.data?.subject?.subject_name}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className='fw-bold text-muted border-0 py-3'>Years of Fellowship:</td>
                                                        <td className='border-0 py-3'></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default FellowInformation;